export const basic_monthly = "BASIC_MONTHLY";
export const basic_monthly_2 = "BASIC_MONTHLY_2";
export const basic_yearly = "BASIC_YEARLY";
